module.exports = __webpack_public_path__ + "static/media/video.a8ae25ec.mp4";